import React, { useCallback, useEffect, useState } from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import LlmProviderDialog from "./LlmProviderForm";
import ToolBar from "../../components/Layout/ToolBar";
import useTable from '../../components/useTable';
import * as llmProviderService from '../../services/llmProviderService';
import ActionsTableCell from '../../components/MaterialTable/ActionsTableCell';
import useAlert from '../../components/useAlert';
import useLinearProgress from '../../components/useLinearProgress';
import AlertDialog from '../../components/AlertDialog';

const llmProviderColumns = [
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Name' },
];

const LLM_PROVIDER_DIALOGS = {
    CREATE_EDIT_DIALOG: 'llm_provider',
    CONFIRMATION_DIALOG: 'alert'
}

const LlmProviders = () => {
    const [llmProviders, setLlmProviders] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [open, setOpen] = useState(false);
    const [dialogType, setDialogType] = useState("");

    const {
        TblContainer,
        TblHead
    } = useTable(llmProviders, llmProviderColumns);

    const {
        Alert,
        status,
        showSuccess,
        showError
    } = useAlert();

    const {
        LinearPorgress,
        isLoading,
        setIsLoading
    } = useLinearProgress(true);

    const getLlmProviders = useCallback(() => {
        llmProviderService.getLlmProviders()
            .then((response) => {
                const result = response.data.items;
                setLlmProviders(result || []);
            })
            .catch(error => {
                showError(error.response?.data?.message || "Error fetching LLM Providers");
            }).finally(() => {
                setIsLoading(false);
            });
    }, [showError, setIsLoading]);

    useEffect(() => {
        getLlmProviders();
    }, [getLlmProviders]);

    const handleDeleteClicked = () => {
        llmProviderService.removeLlmProvider(selectedRow.id)
            .then(() => {
                showSuccess();
                getLlmProviders();
            }).catch(error => {
                showError(error.response?.data?.message || "Error deleting LLM Provider");
            });
    }

    return (
        <React.Fragment>
            {status ? <Alert /> : null}
            <ToolBar
                title="Add LLM Provider"
                setOpen={() => {
                    setSelectedRow(null);
                    setDialogType(LLM_PROVIDER_DIALOGS.CREATE_EDIT_DIALOG);
                    setOpen(true);
                }}
            />
            {isLoading ? <LinearPorgress /> :
            <TblContainer>
                <TblHead />
                <TableBody>
                    {llmProviders && llmProviders.map(key => (
                        <TableRow
                            key={key.id}
                            onClick={() => setSelectedRow(key)}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell >{key.id}</TableCell>
                            <TableCell >{key.name}</TableCell>
                            <ActionsTableCell
                                onEdit={() => {
                                    setDialogType(LLM_PROVIDER_DIALOGS.CREATE_EDIT_DIALOG);
                                    setOpen(true);
                                }}
                                onDelete={(e) => {
                                    setDialogType(LLM_PROVIDER_DIALOGS.CONFIRMATION_DIALOG);
                                    setOpen(true);
                                }}
                            />
                        </TableRow>
                    ))}
                </TableBody>
            </TblContainer>}
            {dialogType === LLM_PROVIDER_DIALOGS.CREATE_EDIT_DIALOG ?
                <LlmProviderDialog
                    open={open}
                    setOpen={setOpen}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    getLlmProviders={getLlmProviders}
                />
                : dialogType === LLM_PROVIDER_DIALOGS.CONFIRMATION_DIALOG ?
                    <AlertDialog
                        open={open}
                        setOpen={setOpen}
                        setSelectedRow={setSelectedRow}
                        confirmAction={handleDeleteClicked}
                    />
                    : null
            }
        </React.Fragment>
    );
}

export default LlmProviders;
